import Skeleton from "react-loading-skeleton";

import { IntegrationConfigurationPanelSkeleton } from "../IntegrationConfigurationPanel/IntegrationConfigurationPanelSkeleton";
import styles from "./IntegrationContainer.module.scss";

export const IntegrationContainerSkeleton = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Skeleton height={20} width={140} />
      </div>
      <IntegrationConfigurationPanelSkeleton />
    </div>
  );
};
